import { waitForScripts } from "../../../../utils.js";

const DEBUG_PREFIX = "https://showdebuginfo.tools.mdgapp.net";

const debugInfoEnabled = () => window.location.href.indexOf("..showdebuginfo..=on") >= 0;

// Utility function for extracting the debug data from responses
const extractDataAndDebug = (responseText) => {
  if (responseText.indexOf("<pre>") >= 0) {
    const scripts = [];

    const doc = document.createElement("div");
    doc.innerHTML = responseText;

    const data = doc.querySelector("pre")?.innerText || "";
    for (const script of doc.querySelectorAll("script")) {
      if (script.innerText.length > 0) {
        scripts.push(script.innerText);
      }
    }
    return { data, script: scripts.join("\n") };
  } else {
    const debugStartIndex = responseText.indexOf("Debug.url");
    return {
      data: JSON.parse(responseText.substring(0, debugStartIndex)),
      script: responseText.substring(debugStartIndex),
    };
  }
};

export const debugRequestInterceptor = () => (config) => {
  // Stop here if debug isn't enabled
  if (!debugInfoEnabled()) {
    return config;
  }

  if (!window.Debug) {
    const debugScript = document.createElement("script");
    debugScript.src = `${DEBUG_PREFIX}/resources/script/debug.js`;
    document.body.appendChild(debugScript);

    // Intercept the URL setting to make sure it goes to our default
    waitForScripts([debugScript], 5000)
      .then(() => Object.defineProperty(window.Debug, 'url', {
        get: () =>
          `${DEBUG_PREFIX}/index.html`,
        set: () => true
      }));
  }

  if (!config.params) {
    config.params = {};
  }
  config.params["..showdebugdata.."] = "on";

  return config;
};

export const debugResponseInterceptor = () => (config) => {
  // Stop here if debug isn't enabled
  if (!debugInfoEnabled()) {
    return config;
  }

  if (config.data) {
    const { data, script } = extractDataAndDebug(config.data);
    config.data = data;
    eval(script);
  }

  return config;
};